import { Component } from '@opten/compiler/metadata/component';
import debounce from '@opten/reactive/debounce';
import hasClass from '@opten/dom/has-class';
import { tns } from 'tiny-slider/src/tiny-slider.module.js';
import 'tiny-slider/src/tiny-slider.scss';
import newGuid from '@opten/common/new-guid';

@Component({ className: 'js-slider' })
export class IconSlider {

	private slider: any;
	private id: string;

	constructor(private element: HTMLElement) {
		this.id = newGuid();
		this.element.setAttribute('data-guid', this.id);
		this.init();
		window.addEventListener('resize', debounce(() => this.init(), 1000));
	}

	private init() {
		if (window.innerWidth > 992) {
			this.destroy();
		} else {
			this.build();
		}
	}

	private build() {
		this.element = document.querySelector(`[data-guid="${this.id}"]`);

		if (!this.slider && this.element) {
			this.slider = tns({
				container: this.element,
				items: 1,
				autoHeight: true,
				controlsContainer: false,
				controls: false,
				nav: true,
				touch: true,
			});
		}
	}

	private destroy() {
		if (this.slider) {
			this.slider.destroy();
			this.slider = null;
		}
	}
}
